const audioAbbreviationsSagaNamespace = 'audio-abbreviations-saga';

// Saga action types
export const GET_ALL_AUDIO_ABBREVIATIONS = `${audioAbbreviationsSagaNamespace}/GET_ALL_AUDIO_ABBREVIATIONS`;
export const CREATE_OR_UPDATE_AUDIO_ABBREVIATION = `${audioAbbreviationsSagaNamespace}/CREATE_OR_UPDATE_AUDIO_ABBREVIATION`;
export const CREATE_OR_UPDATE_MULTIPLE_AUDIO_ABBREVIATIONS = `${audioAbbreviationsSagaNamespace}/CREATE_OR_UPDATE_MULTIPLE_AUDIO_ABBREVIATIONS`;
export const CREATE_OR_UPDATE_MULTIPLE_AUDIO_ABBREVIATIONS_FAIL = `${audioAbbreviationsSagaNamespace}/CREATE_OR_UPDATE_MULTIPLE_AUDIO_ABBREVIATIONS_FAIL`;
export const DELETE_AUDIO_ABBREVIATION = `${audioAbbreviationsSagaNamespace}/DELETE_AUDIO_ABBREVIATION`;
